import { color } from '@upstox/upstox-ui';

export const optionChainTableContainer: CSSFunction = ({ theme }) => ({
  border: `1px solid ${color(theme, theme.colors.ui3)}`,
  width: '100%',
});

export const callPutContainer: CSSFunction = () => ({
  position: 'relative',
  display: 'flex',
  flex: '1 1 auto',
});

export const optionChainTableWrapper: CSSFunction = () => ({
  position: 'absolute',
  top: '0px',
  width: '100%',
});

export const tableContainer: CSSFunction = () => ({
  overflow: 'auto',
  flex: 1,
  display: 'block',
  position: 'relative',
});

export const strikesTableContainer: CSSFunction = () => ({
  overflow: 'auto',
  display: 'block',
  width: '100px',
});

export const callPutLabelWrapper: CSSFunction = ({ cssProps, theme }) => {
  const { isCall } = cssProps;

  return {
    position: 'absolute',
    top: 18,
    transform: 'translate(0, -50%)',
    ...(isCall ? { right: 0, paddingRight: 4 } : { left: 0, paddingLeft: 4 }),
    background: theme.colors.background.default,
    zIndex: 5,
  };
};

export const callPutLabelContainer: CSSFunction = () => ({
  position: 'relative',
});

export const callPutLabelContent: CSSFunction = ({ cssProps }) => {
  const { isCall } = cssProps;

  return {
    position: 'sticky',
    top: 0,
    height: 24,
    ...(isCall ? { right: 4 } : { left: 4 }),
    flexDirection: isCall ? 'row' : 'row-reverse',
  };
};

export const callPutLabel: CSSFunction = ({ theme }) => ({
  color: color(theme, 'interactive.primary.default'),
  fontFamily: 'Messina Sans',
  fontSize: 14,
  fontWeight: 700,
  lineHeight: 24,
});
